import { createNamespace } from "./createNamespace";

export const createThunkName = (name: string) => {
  return createNamespace(`thunk/${name}`);
};
